import checkIcon from '../../assets/icons/check.svg';
import crossIcon from '../../assets/icons/cross.svg';

type Props = {
  checked: boolean;
};

const CheckIcon = ({ checked }: Props) => {
  return (
    <img
      alt='delete-icon'
      src={checked ? checkIcon : crossIcon}
      style={{
        width: '25px',
      }}
      className='m-auto d-flex '
    />
  );
};

export default CheckIcon;
